import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { ICMS1TaxTable } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class ICMS1Repository extends RepositoryBase<ICMS1TaxTable> {
  protected readonly KEY_PATH = 'icms1';
}
